import { injectGlobal } from 'emotion';
import styles from './styles/index.css';

export default () => injectGlobal(styles);
